module.exports = __webpack_public_path__ + "img/noto_kiss-mark_5.63c27152.png";